var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.941,
    height: 26.399,
    viewBox: "0 0 21.941 26.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_567",
    "data-name": "Trac\\xE9 567",
    d: "M-166.765-44.543a2.378,2.378,0,0,0-2.129-.323,11.34,11.34,0,0,1-4.479.566,12.7,12.7,0,0,1-3.133-.7c-.589-.19-1.23-.394-2.02-.6a17.625,17.625,0,0,0-7.243-.235,2.334,2.334,0,0,0-1.981,2.3V-20.7a1,1,0,0,0,1,1,1,1,0,0,0,1-1V-30.7a9.7,9.7,0,0,1,4.308-.976,10.268,10.268,0,0,1,3.67.816c.445.162.895.324,1.371.471a16.079,16.079,0,0,0,4.7.674,20.723,20.723,0,0,0,3.991-.406,2.352,2.352,0,0,0,1.9-2.291V-42.668A2.291,2.291,0,0,0-166.765-44.543ZM-167.8-32.407a.345.345,0,0,1-.3.332,15.841,15.841,0,0,1-7.726-.219c-.441-.133-.858-.286-1.27-.436a12.208,12.208,0,0,0-4.326-.936h-.152a11.73,11.73,0,0,0-4.183.793V-43.537a.349.349,0,0,1,.307-.334,15.566,15.566,0,0,1,6.425.2c.747.191,1.352.386,1.908.564a14.414,14.414,0,0,0,3.577.793,13.307,13.307,0,0,0,5.269-.66.376.376,0,0,1,.335.047.306.306,0,0,1,.13.258Z",
    transform: "translate(187.75 46.103)",
    fill: "#19c3b9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.be16fa77daf6a0a102b091206447cdc0.svg";
export { ForwardRef as ReactComponent };